// extracted by mini-css-extract-plugin
export var controlsContainer = "styles-module__controlsContainer___CAM9s";
export var trailInfoContainer = "styles-module__trailInfoContainer___oOPc2";
export var trailName = "styles-module__trailName___YNAMA";
export var trailLocation = "styles-module__trailLocation___QxB_R";
export var playPause = "styles-module__playPause___JeGao";
export var flyoverExit = "styles-module__flyoverExit___Yhqfu";
export var flyoverTooltip = "styles-module__flyoverTooltip___o_Ea9";